<template>
  <div :key="keyValue" >
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="bankingInfo_tooltip_NAME"  :name="bankingInfo_tooltip_NAME" :description="bankingInfo_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
    <div  v-if="isMonetaryAndUSBuyingOrder || (isPartial && !isPartnerAccount)">
      <div class="col-sm-6">
        <el-alert
          type="warning"
          :closable="false"
          title="Important Information"
          description="All fields are mandatory for Buy orders.  Bank name and address required for Sell orders (additional fields optional)."
          show-icon
          effect="dark"
        >
        </el-alert>
      </div>
      <div class="row">
        <div class="col-sm-6 more-top-padding">
          <label for="BankDropdown">Bank</label>
      <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="bank_tooltip_name" :name="bank_tooltip_name" :description="bank_tooltip_description" :editable="editable"></tool-tip>
    
          <v-select
            :disabled="isReadOnly"
            v-model.trim="bankingInfo.bankId"
            :reduce="(bankingOffice) => bankingOffice.id"
            label="bankName"
            :options="paginated"
            :filterable="false"
            placeholder="Select an option"
            data-vv-as="Bank"
            @input="bankSelected"
            name="bankId"
            @search="searchBank"
            @open="onOpen"
            @close="onClose"
          >
            <template #list-footer>
              <li v-show="hasNextPage" ref="load" class="loader">
                Loading more options... 
              </li>
            </template>
          </v-select>
        </div>
      </div>
      <div class="col-sm-6 more-top-padding">
        <label for="bankName">Bank Name</label>
        <base-input
          id="bankName"
          :disabled="isReadOnly || isPartnerAccount"
          v-model="bankingInfo.name"
          name="bankName"
        >
        </base-input>
          <span v-show="errors.has('bankName')" class="error"
            >Bank Name is required
          </span>
      
      </div>
      <div class="col-sm-6 more-top-padding">
        <label for="bankAddress">Bank Address</label>
        <base-input
          id="bankAddress"
          :disabled="isReadOnly || isPartnerAccount"
          v-model.trim="bankingInfo.address"
          name="bankAddress"
        >
        </base-input>
        <span v-show="errors.has('bankAddress')" class="error"
            >Bank Address is required
          </span>
      </div>
      <div class="col-sm-6 more-top-padding">
        <label for="accountName">Account Name / No.</label>
        <base-input
          id="accountName"
          :disabled="isReadOnly || isPartnerAccount"
          v-model.trim="bankingInfo.accountNumber"
          name="accountNumber"
        >
        </base-input>
        <span v-show="errors.has('accountNumber')" class="error"
            >Account Number is required
          </span>
      </div>
      <div class="col-sm-6 more-top-padding">
        <label for="iban">International Bank Account Number (IBAN)</label>
        <base-input
          id="iban"
          :disabled="isReadOnly || isPartnerAccount"
          v-model.trim="bankingInfo.internationalBankAccountNumber_IBAN"
          name="internationalBankAccountNumber_IBAN"
        >
        </base-input>
        <span v-show="errors.has('internationalBankAccountNumber_IBAN')" class="error"
            >International Bank Account Number (IBAN) is required
          </span>
      </div>
      <div class="col-sm-12 more-top-padding">
        <label for="swiftAba">SWIFT / ABA</label>
        <base-input
          id="swiftAba"
          :disabled="isReadOnly || isPartnerAccount"
          v-model.trim="bankingInfo.swiftAba"
          name="swiftAba"
        >
        </base-input>
        <span v-show="errors.has('swiftAba')" class="error"
            >SWIFT / ABA is required
          </span>
      </div>
      <div class="row justify-content-center">
        <div class="col-sm-6">
          <label>Billing Date</label>
          <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="billingDate_NAME"  :name="billingDate_NAME" :description="billingDate_DESCRIPTION" :editable="editable"></tool-tip>

          <el-date-picker
            :disabled="isReadOnly || isPartnerAccount"
            v-model="bankingInfo.billingDate"
            type="date"
            :editable="false"
            format="dd-MMMM-yyyy"
            placeholder=""
            data-vv-as="Billing Date"
            name="billingDate"
          >
          </el-date-picker>
        </div>
        <div class="col-sm-6">
          <label>Payment Due Date</label>
    <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="paymentDueDate_NAME"  :name="paymentDueDate_NAME" :description="paymentDueDate_DESCRIPTION" :editable="editable"></tool-tip>


          <el-date-picker
            :disabled="isReadOnly || isPartnerAccount"
            v-model="bankingInfo.paymentDueDate"
            type="date"
            :editable="false"
            format="dd-MMMM-yyyy"
            placeholder=""
            data-vv-as="Payment Due Date"
            name="paymentDueDate"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-sm-12 more-top-padding">
          <div class="pull-right">
            <base-button
              :disabled="isReadOnly || isPartnerAccount"
              type="primary"
              wide
              @click.native="submit"
              class="btn-next"
              >Save</base-button
            >
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-sm-12 more-top-padding">
          Banking Information is not required for this transaction... Please
          Continue..
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Alert } from "element-ui";
import Utility from "@/mixins/utility/utility";
import Util from "../../../../util/util";
import  toolTip  from "../../Tooltip";

export default {
  props: ["isReadOnly"],
  name: "BankingInformation",
  mixins: [Utility],
  data() {
    return {
      searchTerm: "",
      observer: null,
      limit: 5,
      pageNumber: 1,
      bank_tooltip_name: '',
      bank_tooltip_description: '',
      bankingInfo_tooltip_NAME : '',
      bankingInfo_tooltip_DESCRIPTION : '',
      billingDate_NAME:'',
      billingDate_DESCRIPTION:'',
      paymentDueDate_NAME:'',
      paymentDueDate_DESCRIPTION:'',
      keyValue: 0
    };
  },
  components: {
    [Alert.name]: Alert,
    toolTip
  },
  computed: {
    ...mapGetters({
      bankingInfo: "bankingInformation/bankingInfo",
      bankingInfoErrors: "bankingInformation/bankingInfoErrors",
      preOrder: "preOrderDetail/preOrder",
      isRikOrEveOrder: "preOrderDetail/isRikOrEveOrder",
      returnReplacementReceiptAcknowledgment:
        "returnReplacementReceiptAcknowledgment/returnReplacementReceiptAcknowledgment",
      isMonetaryOrder: "preOrderDetail/isMonetaryOrder",
      isPartnerAccount: "authentication/isPartnerAccount",
      countriesOptions: "countries/allCountries",
      allBankingOffices: "bankingOffice/paginatedBankingOffices",
      getPageInformation: "bankingOffice/getPageInformation",
      agreementInfo: "agreementInformation/agreementInfo",
      usOffices: "financialOffice/usOffices",
      toolTips: "tooltip/tooltips",
      order: "orders/order",
      editable: "tooltip/editable"
    }),
    typeOfTransaction() {
      return this.order ? this.order.usBuySell : "N/A";
    },
    isFieldRequired() {
      return  this.typeOfTransaction == 'BUY' ? 'required' : ''
    },
    fieldsAreEmpty() {
      if(this.bankingInfo.name != '' && this.bankingInfo.address != '' && this.bankingInfo.accountNumber != '' && this.bankingInfo.internationalBankAccountNumber_IBAN != '' && this.bankingInfo.swiftAba != ''){
        return false;
      }
      if(!this.bankingInfo.name && !this.bankingInfo.address  && !this.bankingInfo.accountNumber  && !this.bankingInfo.internationalBankAccountNumber_IBAN && !this.bankingInfo.swiftAba ){
          this.bankingInfo.name = '';
          this.bankingInfo.address = '';
          this.bankingInfo.accountNumber = '';
          this.bankingInfo.internationalBankAccountNumber_IBAN = '';
          this.bankingInfo.swiftAba = '';
          return false 
      }else{
        return true
      }
    },
    getOrderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
    isPartial() {
      return this.returnReplacementReceiptAcknowledgment.isPartialReturn;
    },
    isMonetaryAndUSBuyingOrder() {
      return this.isMonetaryOrder && this.preOrder.usBuySell === Util.US_BUY;
    },
    filteredBanks() {
      if (this.allBankingOffices && this.allBankingOffices.length === 0) {
        return [];
      } else {
        if (this.searchTerm) {
          return this.allBankingOffices.filter((bank) =>
            bank.bankName
              .toLocaleLowerCase()
              .includes(this.searchTerm.toLocaleLowerCase())
          );
        } else {
          return this.allBankingOffices;
        }
      }
    },
    paginated() {
      return this.filteredBanks.slice(0, this.limit);
    },
    hasNextPage() {
      return this.paginated.length < this.filteredBanks.length;
    },
    isUsSellOrder() {
      return this.preOrder.usBuySell === Util.US_SELL;
    },
  },
  watch: {
    isMonetaryAndUSBuyingOrder(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getBankingInformationStatus(this.getOrderIdFromRoute);
      }
    },
    "agreementInfo.countryId": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getAllBankingOfficesFromBackend();
      }
    },
  },
  async mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll);
    await this.getAllTooltips()
   this.loadToolTips()
  },
  methods: {
    ...mapActions({
      loadBankingInformation: "bankingInformation/loadBankingInformation",
      getBankingInformationStatus:
        "bankingInformation/getBankingInformationStatus",
      saveBankingInfoToServer: "bankingInformation/saveBankingInfoToServer",
      setBankingInformation: "bankingInformation/setBankingInformation",
      paginatedBankingOffices: "bankingOffice/getPaginatedBankingOffices",
      loadAgreementInformation: "agreementInformation/loadAgreementInformation",
      getUsFinanceOffices: "financialOffice/getUsFinanceOffices",
      getAllTooltips: "tooltip/getToolTips"

    }),
    loadToolTips(){
    const bankTooltip = this.toolTips.find(e => e.name === "Bank")
    const bankingInfoVal = this.toolTips.find(e => e.name === "BankingInfoModule")
    const billingDate_tooltip = this.toolTips.find(e => e.name === "BillingDate")
    const paymentDueDate_tooltip = this.toolTips.find(e => e.name === "PaymentDueDate")
    
     if(billingDate_tooltip && billingDate_tooltip.status){
    this.billingDate_DESCRIPTION = billingDate_tooltip.description ? billingDate_tooltip.description: null
    this.billingDate_NAME = billingDate_tooltip.name ? billingDate_tooltip.name: null
    }
    if(paymentDueDate_tooltip && paymentDueDate_tooltip.status){
    this.paymentDueDate_DESCRIPTION = paymentDueDate_tooltip.description ? paymentDueDate_tooltip.description: null
    this.paymentDueDate_NAME = paymentDueDate_tooltip.name ? paymentDueDate_tooltip.name: null
    }
    
    if(bankingInfoVal && bankingInfoVal.status){
    this.bankingInfo_tooltip_DESCRIPTION = bankingInfoVal.description ? bankingInfoVal.description: null
    this.bankingInfo_tooltip_NAME = bankingInfoVal.name ? bankingInfoVal.name: null
    }
    if(bankTooltip && bankTooltip.status){
      this.bank_tooltip_description = bankTooltip.description ? bankTooltip.description :  null
      this.bank_tooltip_name = bankTooltip.name ? bankTooltip.name :  null

    }
    return },
    updateToolTip(updatedData){
      this.loadToolTips()
      },
    loaded() {
      this.loadBankingInformation(this.getOrderIdFromRoute);
      this.getBankingInformationStatus(this.getOrderIdFromRoute);
      this.loadAgreementInformation(this.getOrderIdFromRoute).then(() => {
        this.getAllBankingOfficesFromBackend();
      });
    },
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load);
      }
    },
    onClose() {
      this.observer.disconnect();
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const scrollTop = target.offsetParent.scrollTop;
        this.limit += 5;
        await this.getAllBankingOfficesFromBackend();
        await this.$nextTick();
        ul.scrollTop = scrollTop;
      }
    },
    getAllBankingOfficesFromBackend() {
      let apiInfo = {
        pageNumber: 1,
        resultsPerPage: this.limit + 5,
        exportToExcel: false,
        searchText: "",
        countryId: "",
      };

      if (this.isUsSellOrder) {
        this.getUsFinanceOffices().then(() => {
          const usId =
            this.usOffices.length > 0 ? this.usOffices[0].countryId : "";
          this.paginatedBankingOffices({
            pageNumber: 1,
            resultsPerPage: this.limit + 5,
            exportToExcel: false,
            searchText: "",
            countryId: usId,
          });
        });
      } else {
        this.paginatedBankingOffices({
          pageNumber: 1,
          resultsPerPage: this.limit + 5,
          exportToExcel: false,
          searchText: "",
          countryId: this.agreementInfo.countryId,
        });
      }
    },
    showBankingInformationErrors() {
      if (this.bankingInfoErrors && this.bankingInfoErrors.length > 0) {
        this.bankingInfoErrors.forEach((error) => this.$toast.error(error));
      }
    },
    async submit(e) {
     
      // if(this.fieldsAreEmpty) {
      //    this.$toast.error('Banking information fields are empty!!');
      //   return;
      // }
      this.$validator.validateAll().then((result) => {
        if (result) {
          let ctx = this;
          this.saveBankingInfoToServer(this.getOrderIdFromRoute)
            .then(() => {
              ctx
                .getBankingInformationStatus(ctx.getOrderIdFromRoute)
                .then(() => {
                  ctx.showBankingInformationErrors();
                });
              ctx.loadBankingInformation(this.getOrderIdFromRoute);
            })
            .catch((errorMessage) => {
              this.$toast.error(errorMessage);
            });
        } else {
          this.$toast.error("Please fill the required fields.");
        }
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    bankSelected(value) {
      if (value) {
        const bank = this.allBankingOffices.filter((bank) => bank.id === value);
        this.setBankingInformation(Array.isArray(bank) ? bank[0] : bank);
      }
    },
    searchBank(query) {
      this.searchTerm = query;
      this.offset = 0;
    },
  },
};
</script>

<style>
@import "../../../../../../client-app/public/AGATRS.css";
</style>

<style scoped>
.optinal-message {
  color: red;
}

.loader {
  text-align: center;
  color: #bbbbbb;
}
</style>
